export const FRONT_RELATED_TYPE = 1;
export const BACK_RELATED_TYPE = 2;

export const RESIDENCE_TYPE = [FRONT_RELATED_TYPE, BACK_RELATED_TYPE];

export const CV_RELATED_TYPE = 3;

export const MESSAGE_EMPTY_DATA_FROM_SCAN = "メモか書類のどちらかを入力してください。";
